const withProps = (Component, props) => {
  return function (routeProps) {
    return <Component {...props} {...routeProps} />;
  };
};

export default withProps;
